export default __webpack_public_path__ + "static/media/soil_moisture.eae93aec.svg";